export const Logo = ({ light = false }) => (
  <span className="inline-flex items-center gap-2.5">
    <img
      src="/assets/banga-logo.png"
      alt=""
      className="h-8 w-8 rounded-md object-cover"
      aria-hidden="true"
    />
    <span
      className={`font-heading text-lg font-extrabold tracking-tight ${
        light ? "text-white" : "text-gray-900"
      }`}
    >
      Banga Pay
    </span>
  </span>
);
